module.exports = __webpack_public_path__ + "media/images/integration_logo_focco_delivery-6cd4a8416ebbbed9db1465cd1f0c9a13.svg";